class window.MapEditor
    self = undefined

    constructor: () ->
        self = this

        map = $('.map')
        circles = $('[data-territory]').parent()

        circles.mousedown((e) ->
            if self.selected?
                self.handleDrop

            self.selected = $(this)

            self.startMouseX = e.pageX
            self.startMouseY = e.pageY

            self.startTerrX = parseInt($(this).css('left'))
            self.startTerrY = parseInt($(this).css('top'))
        )

        map.mousemove((e) ->
            if not self.selected?
                return false

            diffX = e.pageX - self.startMouseX
            diffY = e.pageY - self.startMouseY

            self.selected.css('left', (self.startTerrX + diffX) + 'px')
            self.selected.css('top', (self.startTerrY + diffY) + 'px')
        )

        $('html').mouseup(() ->
            if self.selected?
                self.handleDrop()
                self.selected = null
        )

        $('[name^=terrX]').blur(() ->
            terrID = $(this).closest('.terr-row').data('terrId')
            $("[data-territory=#{terrID}]").parent().css('left', parseInt($(this).val()) + 'px')
        )
        $('[name^=terrY]').blur(() ->
            terrID = $(this).closest('.terr-row').data('terrId')
            $("[data-territory=#{terrID}]").parent().css('top', parseInt($(this).val()) + 'px')
        )

    handleDrop: () ->
        x = parseInt(self.selected.css('left'))
        y = parseInt(self.selected.css('top'))

        terrID = self.selected.find('[data-territory]').data('territory')

        $("[name=\"terrX[#{terrID}]\"]").val(x)
        $("[name=\"terrY[#{terrID}]\"]").val(y)
